"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tableHeaderColumn_1 = require("../tableHeaderColumn");
var checkbox_1 = require("../checkbox");
exports.default = (function (_a) {
    var /* add non ICheckboxProps here */ others = tslib_1.__rest(_a, []);
    return (React.createElement(tableHeaderColumn_1.TableHeaderColumn, { slim: true },
        React.createElement(checkbox_1.Checkbox, tslib_1.__assign({}, others))));
});
